exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir=ltr] .va-container.va-border-right{border-right:1px solid #707372}[dir=rtl] .va-container.va-border-right{border-left:1px solid #707372}.va-container .va-icon-container{width:30px;height:30px}[dir] .va-container .va-icon-container{margin-top:7px}.va-container .va-icon-container svg .st0{fill:#707372;stroke:none}.va-container .va-message-container{-ms-flex-align:center;align-items:center}[dir=ltr] .va-container .va-message-container{padding-left:7px}[dir=rtl] .va-container .va-message-container{padding-right:7px}[dir] .va-container .va-message-container .va-btn{background-color:transparent;cursor:pointer}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/virtual-assistant/virtual-assistant.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/virtual-assistant/virtual-assistant.component.scss
// module chunks = 0